module.exports = "<!--<header >-->\n  <mat-toolbar color=\"primary\">\n    <button mat-icon-button (click)=\"toggle()\"><mat-icon>menu</mat-icon></button>\n    <h1>Responsive App</h1>\n  </mat-toolbar>\n\n<!--</header>-->\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/bruna/Desktop/nuresp/src/app/components/app-header/app-header.component.html
// module id = ../../../../../src/app/components/app-header/app-header.component.html
// module chunks = main